
import { Options, Vue, prop } from "vue-class-component";
import Modal from "@/app/ui/components/modal/index.vue";
import LpButton from "@/app/ui/components/lp-button/index.vue";
import formatPriceRP from "@/app/infrastructures/misc/common-library/FormatPriceRP";
import CustomOverlay from "@/app/ui/components/breadcrumb-v2/overlayPanelCustom.vue";
import { SuccessInvoiceData } from "@/domain/entities/PrintReceipt";
import formatPrice from '@/app/infrastructures/misc/common-library/v2/FormatPrice';
import { AccountController } from '@/app/ui/controllers/AccountController';

class Props {
  visible = prop<boolean>({
    default: false,
    required: true
  });
  mode = prop<"create" | "update">({
    required: true
  });
  invoiceData = prop<SuccessInvoiceData>({
    required: true
  });
}

@Options({
  components: {
    Modal,
    LpButton,
    CustomOverlay
  },
  emits: ["update:visible", "close", "download"]
})
export default class ModalSuccessReceipt extends Vue.with(Props) {
  get downloadOptions() {
    return [
      { label: this.$t("tagihan.modal.downloadPdfA4"), value: "pdf_a4" },
      { label: this.$t("tagihan.modal.downloadPngA4"), value: "png_a4" },
      { label: this.$t("tagihan.modal.downloadStruk"), value: "struk" }
    ];
  }

  get titleText() {
    return this.mode === "create"
      ? this.$t("tagihan.modal.successCreate")
      : this.$t("tagihan.modal.successUpdate");
  }

  get maskingPhoneNumber() {
    return this.invoiceData.bookedByPhone.replace(
      /^(\d{2})(\d+)(\d{3})$/,
      (_, start, middle, end) => start + "*".repeat(middle.length) + end
    );
  }

  get amountLabel() {
    return this.mode === "create"
      ? this.$t("tagihan.modal.totalAmount")
      : this.$t("tagihan.modal.remainingLabel");
  }

  get accountCurrency() {
    return (
      (AccountController.accountData?.accountCurrency as "IDR" | "MYR") ?? "IDR"
    );
  }

  get formattedAmount() {
    const value =
      this.mode === "create"
        ? this.invoiceData.totalAmount
        : this.invoiceData.balanceDue;
    return formatPrice(value, "", this.accountCurrency as "IDR" | "MYR");
  }

  onClose() {
    this.$emit("update:visible", false);
    this.$emit("close");
  }

  onDownload(type: string) {
    this.$emit("download", { key: type });
    (this.$refs.customOverlay as any).isOpen = false;
  }
}
